import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Nav, NavItem, Row, Col, ButtonToolbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import FontAwesome from 'react-fontawesome';
import TimetableListView from './listView';
import BookingOptions from './listView/BookingOptions';
import ClassDetailsView from './listView/Details';
import GradesDropdown from '../../common/components/GradesDropdown';
import moment from 'moment';
import { withNamespaces, Trans } from 'react-i18next';
import WeekdaysDropdown from '../../common/components/WeekdaysDropdown';
import TermsDropdown from '../../common/components/TermsDropdown';
import CenterDetailsLink from '../../common/components/CenterDetailsLink';
import utils from '../../common/services/utils';
import availabilityUtils from './availabilityUtils';
import RecommendedNearbyCenters from './RecommendedNearbyCenters';

class ClassList extends Component {
	constructor(props) {
		super(props);

		this.handleTermSelect = this.handleTermSelect.bind(this);

		this.state = {
			selectedDate: new Date()
		};
	}

	componentDidMount() {
		if (this.props.bookingOptions.selectedPaymentTypeId || this.props.bookingOptions.isSelectJoinWaitingList ||
			(this.props.bookingOptions.programId && this.props.bookingOptions.date && this.props.bookingOptions.selectedChildId)) {
			this.props.onValidateBookingOptions();	// validate selected options and continue to Confirm
		}

		if (this.props.selectedTerm) {
			this.props.onLoadWeeklyProgram();
		}

		window.scrollTo(0, 0);
	}

	componentWillReceiveProps(nextProps) {
		if (!this.props.selectedProgramItem && nextProps.selectedProgramItem) {
			window.scrollTo(0, 0);
		}
	}

	handleTermSelect(termId) {
		this.props.onSelectTerm(termId);
		this.props.onUnselectLesson();
	}

	renderTermsSelector() {
		const { terms, selectedTerm } = this.props;
		const sortedTerms = terms.sort(function (a, b) {
			return moment(a.startDate).format('YYYYMMDD') - moment(b.startDate).format('YYYYMMDD');
		});

		return <Nav bsStyle='tabs' activeKey={selectedTerm.id} onSelect={key => this.handleTermSelect(key)}>
			{sortedTerms.map(term => {
				return <NavItem key={term.id} eventKey={term.id}>
					<div>{term.name}</div>
					<div>{moment(term.startDate).format('DD/MM')} - {moment(term.endDate).format('DD/MM')}</div>
				</NavItem>;
			})}
		</Nav>;
	}

	getPageTitleKey(lessonType) {
		let titleResource = 'FO_Booking_Class_Title';
		switch (lessonType) {
			case 'trial':
				titleResource = 'FO_Booking_Class_Trial';
				break;
			case 'makeup':
				titleResource = 'FO_Booking_Class_MakeUp';
				break;
		}
		return titleResource;
	}

	getWeekdayByParentZone(programItem) {
		const { selectedCenter, enableUserTimeZone } = this.props;
		const weekday = programItem.lessons.length > 0 && (enableUserTimeZone ? utils.convertToUserTime(programItem.lessons[0].start, selectedCenter) : moment(programItem.lessons[0].start)).day();
		return weekday === 0 ? 7 : weekday;
	}

	render() {
		const {
			weeklyProgram, selectedProgramItem, currentUser,
			terms, selectedTerm, onSelectTerm,
			grades, selectedGrades, onSelectGrades,
			selectedWeekday, onSelectWeekday,
			selectedCenter, allowWorkshops,
			bookingOptions: { selectedChildId, lessonType },
			enableUserTimeZone, enableCurrencyConversion, currentCurrency, franchisorCurrency, t, recommendNearbyCenters, distanceToNearbyCenters
		} = this.props;

		const gradeIds = !selectedGrades || selectedGrades.length === 0 ? null : selectedGrades.map(x => x.id);

		const programInSelectedCenterTermGradesWeekday = weeklyProgram.filter(x => x.centerId === selectedCenter.id && x.termId === selectedTerm.id &&
			(!gradeIds || gradeIds.indexOf(x.gradeId) > -1 || (x.grade.mixed && x.grade.subGrades && x.grade.subGrades.some(s => gradeIds.indexOf(s) > -1))) &&
			(!selectedWeekday || this.getWeekdayByParentZone(x) === selectedWeekday));

		const now = new Date();
		const allLessonDates = selectedProgramItem ? selectedProgramItem.lessons.map(x => x.start).sort((a, b) => a - b) : [];
		const upcomingLessonDates = allLessonDates.filter(x => {
			const lessonStartTime = moment(x).utcOffset(selectedProgramItem.center.utcOffset, true);	// actual start time using center's timezone
			return lessonStartTime > now;
		}).sort((a, b) => a - b);

		const allowFutureBooking = selectedProgramItem && selectedProgramItem.center.allowFutureBooking;
		const nextDate = upcomingLessonDates.length > 0 && upcomingLessonDates[0];

		const bookingDates = currentUser.userImpersonation && allowFutureBooking ? allLessonDates : (allowFutureBooking || lessonType === 'makeup' ? upcomingLessonDates : (nextDate ? [nextDate] : []));

		const availability = selectedProgramItem ? availabilityUtils.getAvailability(this.props.bookingOptions.upcomingLessons || [], lessonType, this.props.paymentTypes, selectedCenter) : '';
		const alternativeCenters = (availability === 'No' && recommendNearbyCenters &&
			availabilityUtils.findNearbyCentersWithAvailableSpotsByWeeklyProgram(selectedCenter, selectedProgramItem, lessonType, this.props.paymentTypes,
				this.props.centers, weeklyProgram, distanceToNearbyCenters)) || [];

		return (
			<div>
				{!selectedProgramItem && <div>
					<div className='steps_title'>
						<Trans i18nKey={this.getPageTitleKey(lessonType)}>
							Select age appropriate class in <CenterDetailsLink center={selectedCenter} hideMapMarker />
						</Trans>
					</div>
					<div className='calendar-container' style={{ width: '100%' }}>
						{/*{this.renderTermsSelector()}*/}
						{/*{selectedTerm.id && <div style={{ padding: '10px' }}>*/}
						<ButtonToolbar className='timetable-search' style={{ marginBottom: '10px' }}>
							<TermsDropdown
								terms={terms}
								selectedTerm={selectedTerm && selectedTerm.id > 0 ? selectedTerm : null}
								onSelectTerm={onSelectTerm}
							/>
							<GradesDropdown
								grades={grades.filter(x => !x.mixed).sort((a, b) => a.fromAge < b.fromAge ? -1 : 1)}
								selectedGrades={selectedGrades}
								onSelectGrades={onSelectGrades}
							/>
							<WeekdaysDropdown selectedWeekday={selectedWeekday} onSelectWeekday={onSelectWeekday} />
						</ButtonToolbar>
						<TimetableListView block={this.props.timetableBlock} unblock={this.props.timetableUnblock}
							lessonType={lessonType}
							center={selectedCenter}
							weeklyProgram={programInSelectedCenterTermGradesWeekday}
							onSelectProgramItem={this.props.onSelectProgramItem}
							enableUserTimeZone={enableUserTimeZone}
							paymentTypes={this.props.paymentTypes}
						/>
						{/*</div>}*/}
						<Row style={{ paddingTop: '10px' }}>
							<Col sm={12}>
								{allowWorkshops && <Link className='btn btn-primary btn-block-xxs pull-right' to={`/public/workshops?centerId=${selectedCenter && selectedCenter.id}`}>{t('FO_MainMenu_Parent_Workshops')} <FontAwesome name='arrow-circle-right' /></Link>}
								<Button className='btn btn-back btn-block-xxs' onClick={this.props.onNavigateBack}><FontAwesome name='arrow-circle-left' /> {t('FO_Booking_Center_Select')}</Button>
							</Col>
						</Row>
					</div>
				</div>}
				{selectedProgramItem && <div>
					<Row>
						<Col md={12}>
							<a className='btn btn-back btn-block-xxs' onClick={this.props.onUnselectProgramItem}><FontAwesome name='arrow-circle-left' /> {t('FO_ProgramDetails_Back')}</a>
						</Col>
					</Row>
					<Row style={{ marginTop: '30px' }}>
						<Col md={8}><div className='booking-options-container' style={{ width: '100%', margin: 0, marginBottom: 20 }}>
							<ClassDetailsView
								weeklyProgramItem={selectedProgramItem}
								upcomingLessonDates={upcomingLessonDates}
								availability={availability}
								enableUserTimeZone={enableUserTimeZone}
							/>
						</div>
						</Col>
						<Col md={4}>
							<BookingOptions
								children={this.props.children}
								programId={selectedProgramItem.id}
								lessonDates={bookingDates}
								nextDate={nextDate}
								bookingOptions={this.props.bookingOptions}
								onSelectStartDate={this.props.onSelectStartDate}
								onSelectPaymentType={this.props.onSelectPaymentType}
								onSelectChild={() => { }}
								onConfirm={this.props.onSaveBooking}
								onJoinWaitingList={this.props.onSelectJoinWaitingList}
								block={this.props.bookingOptionsBlock}
								unblock={this.props.bookingOptionsUnblock}
								blockChildrenInfo={this.props.childrenInfoBlock}
								unblockChildrenInfo={this.props.childrenInfoUnblock}
								center={selectedCenter}
								enableUserTimeZone={enableUserTimeZone}
								enableCurrencyConversion={enableCurrencyConversion}
								currentCurrency={currentCurrency}
								franchisorCurrency={franchisorCurrency}
								isAuthenticated={true}
							/>
							{alternativeCenters.length > 0 && <div style={{ width: '100%', margin: 0, marginBottom: 20 }}>
								<RecommendedNearbyCenters
									centers={alternativeCenters}
									onSelectCenter={this.props.onSelectNearbyCenter}
								/>
							</div>
							}
						</Col>
					</Row>
				</div>}
			</div>
		);
	}
}

ClassList.propTypes = {
	lessonType: PropTypes.oneOf(['', 'normal', 'trial', 'makeup']),
	grades: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string
	})),
	selectedGrades: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string
	})),
	onSelectGrades: PropTypes.func.isRequired,
	selectedWeekday: PropTypes.number,
	onSelectWeekday: PropTypes.func.isRequired,
	weeklyProgram: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number,
		grade: PropTypes.shape({
			name: PropTypes.string
		})
	})),
	onLoadWeeklyProgram: PropTypes.func.isRequired,
	onValidateBookingOptions: PropTypes.func.isRequired,
	onSelectProgramItem: PropTypes.func.isRequired,
	onUnselectProgramItem: PropTypes.func.isRequired,
	onSelectTerm: PropTypes.func.isRequired,
	onSelectPaymentType: PropTypes.func.isRequired,
	onSelectJoinWaitingList: PropTypes.func.isRequired,
	onSaveBooking: PropTypes.func.isRequired,
	onNavigateBack: PropTypes.func.isRequired,
	terms: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string,
		startDate: PropTypes.string,
		endDate: PropTypes.string
	})),
	selectedTerm: PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string,
		startDate: PropTypes.string,
		endDate: PropTypes.string
	}),
	children: PropTypes.arrayOf(PropTypes.shape({
		shortName: PropTypes.string,
		hasTrialLesson: PropTypes.boolean,
		ageAppropriateGrades: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number, name: PropTypes.string }))
	})),
	recommendNearbyCenters: PropTypes.boolean,
	onSelectNearbyCenter: PropTypes.func
};

export default withNamespaces()(ClassList);